import { jsxs as _jsxs, jsx as _jsx } from "react/jsx-runtime";
import { ListItemText } from "@mui/material";
import { EGamePhase, EGameStatus, ERoleTypes, getGameStatusString, } from "../../../types";
import { useAppSelector } from "../../../hooks";
import { selectMatchState, selectShowRoles } from "../../../store/match";
import styled from "styled-components";
import { PrimaryButton } from "../../atoms/PrimaryButton";
import { Portal } from "../../atoms/Portal/Portal";
import { useMemo } from "react";
import { colors } from "../../../styles/colors";
const DeskFooter = styled.div `
  position: fixed;
  z-index: 100000;
  top: 0;
  right: 0;
  bottom: 0;

  display: flex;
  flex-direction: column;
  justify-content: space-between;
  width: 271px;
  padding: 15px 20px 30px;

  background: rgba(23, 28, 31, 0.7);
  backdrop-filter: blur(50px);
  box-shadow: -7px 0px 38.6px 0px rgba(0, 0, 0, 0.25);

  .image {
    display: block;
    width: 79px;
    height: 100px;
    max-width: 100%;
    margin: 0 auto;
  }
`;
const ListWrapper = styled.div `
  align-self: flex-end;
  width: 100%;
`;
const List = styled.ul `
  display: flex;
  flex-direction: column;
  gap: 15px;
  padding: 0;
  margin: 0;
`;
const ListItem = styled.li `
  display: flex;
  justify-content: center;
  align-items: center;
  height: 47px;
  box-sizing: border-box;
  width: 100%;

  text-transform: uppercase;
  color: ${colors.textPrimary};

  border-radius: 5px;
  background-color: ${colors.surface};
  border: 1px solid ${props => props.showRoles ? colors.primary : colors.cardBorder};
  transition: all 0.2s;

  cursor: pointer;

  &:hover {
    background-color: ${colors.surfaceVariant};
    border-color: ${colors.primary};
  }
`;
const GameInfoWrapper = styled.div `
  display: flex;
  flex-direction: column;
  gap: 10px;
  align-items: center;
  margin-top: 30px;

  font-family: "Bowler";
  font-size: 32px;
  color: #fff;
`;
const TextWrapper = styled.p `
  margin: 0;
  margin-top: 10px;

  color: rgba(200, 200, 200, 1);
  font-size: 16px;
  line-height: 18px;
  text-align: center;
  font-family: "Inter";
  font-weight: 400;
`;
const TopWrapepr = styled.div ``;
const Timer = styled.p `
  margin: 0;
  margin-top: 30px;

  font-family: "Bowler";
  text-align: center;
  color: rgba(255, 255, 255, 0.3);
  font-size: 40px;
`;
export const DeskFooterComponent = ({ gameStatus, onFoulsClick, onPassButtonClick, isRequestSent, isThemesLoading, onChangeViewModeClick, gameButtonState, onVotesOpen, onThemesButtonClick, onFixSeatingClick, }) => {
    const showRoles = useAppSelector(selectShowRoles);
    const matchState = useAppSelector(selectMatchState);
    const currentRole = useMemo(() => {
        var _a;
        const key = ((_a = matchState === null || matchState === void 0 ? void 0 : matchState.state) === null || _a === void 0 ? void 0 : _a.currentRole) || ERoleTypes.MAFIA;
        return ((matchState === null || matchState === void 0 ? void 0 : matchState.roles.find((r) => r.machineName === key)) ||
            (matchState === null || matchState === void 0 ? void 0 : matchState.roles[0]));
    }, [matchState]);
    const getAddOnComponent = () => {
        var _a;
        let header = `Действует ${(currentRole === null || currentRole === void 0 ? void 0 : currentRole.name) || "Мафия"}`;
        if ((currentRole === null || currentRole === void 0 ? void 0 : currentRole.machineName) === ERoleTypes.BOMB) {
            const bomb = (_a = matchState === null || matchState === void 0 ? void 0 : matchState.state) === null || _a === void 0 ? void 0 : _a.bomb;
            header = `Бомба минирует: ${bomb === null || bomb === void 0 ? void 0 : bomb.minedNow} из ${bomb === null || bomb === void 0 ? void 0 : bomb.totalToMine}`;
        }
        return header;
    };
    return (_jsx(Portal, { children: _jsxs(DeskFooter, { children: [_jsxs(TopWrapepr, { children: [_jsxs(GameInfoWrapper, { children: [(matchState === null || matchState === void 0 ? void 0 : matchState.gamePhase) === EGamePhase.DAY ? "День" : "Ночь", " \u2116", (matchState === null || matchState === void 0 ? void 0 : matchState.dayNumber) || 1] }), _jsx(TextWrapper, { children: gameStatus === EGameStatus.ROLE_PERFORM_NIGHT_ACTION
                                ? getAddOnComponent()
                                : getGameStatusString(gameStatus) }), (gameButtonState === null || gameButtonState === void 0 ? void 0 : gameButtonState.visible) && gameButtonState.addOnText && (_jsxs(Timer, Object.assign({ className: "timer" }, { children: [gameButtonState.addOnText.minutes, " :", " ", gameButtonState.addOnText.seconds] })))] }), _jsx(ListWrapper, { children: _jsxs(List, { children: [_jsx(ListItem, Object.assign({ onClick: onFoulsClick }, { children: _jsx(ListItemText, { primary: "\u0424\u043E\u043B\u044B" }) })), (gameStatus === EGameStatus.SELECT_WHO_START_VOTING ||
                                gameStatus === EGameStatus.PLAYER_VOTE_STATE ||
                                gameStatus === EGameStatus.PLAYER_VOTING ||
                                gameStatus === EGameStatus.SELECT_DIRECTION_OF_VOTE) && (_jsx(ListItem, Object.assign({ onClick: isRequestSent ? undefined : onPassButtonClick, style: { opacity: isRequestSent ? 0.5 : 1, cursor: isRequestSent ? 'not-allowed' : 'pointer' } }, { children: _jsx(ListItemText, { primary: isRequestSent ? "Выполняется..." : "пас" }) }))), (gameStatus === EGameStatus.SELECT_WHO_START_INTRODUCE ||
                                gameStatus === EGameStatus.INTRODUCE_YOURSELF_STATE ||
                                gameStatus === EGameStatus.SELECT_DIRECTION_OF_INTRODUCE) && (_jsx(ListItem, Object.assign({ onClick: isThemesLoading ? undefined : onThemesButtonClick, style: { opacity: isThemesLoading ? 0.5 : 1, cursor: isThemesLoading ? 'not-allowed' : 'pointer' } }, { children: _jsx(ListItemText, { primary: isThemesLoading ? "Выполняется..." : "Темы представлений" }) }))), (gameStatus === EGameStatus.SELECT_WHO_START_INTRODUCE ||
                                gameStatus === EGameStatus.INTRODUCE_YOURSELF_STATE ||
                                gameStatus === EGameStatus.SELECT_DIRECTION_OF_INTRODUCE ||
                                gameStatus === EGameStatus.PLAYER_INTRODUCING) && onFixSeatingClick && (_jsx(ListItem, Object.assign({ onClick: onFixSeatingClick }, { children: _jsx(ListItemText, { primary: "\u0418\u0441\u043F\u0440\u0430\u0432\u0438\u0442\u044C \u0440\u0430\u0441\u0441\u0430\u0434\u043A\u0443" }) }))), gameStatus !== EGameStatus.NIGHT_RESULT_SHOW_STATE &&
                                gameStatus !== EGameStatus.DAY_RESULT_SHOW_STATE &&
                                gameStatus !== EGameStatus.MORNING_MESSAGE_ACKNOWLEDGMENT_STATE && (_jsx(ListItem, Object.assign({ onClick: onChangeViewModeClick, showRoles: showRoles }, { children: _jsx(ListItemText, { primary: "\u0420\u043E\u043B\u0438" }) }))), (gameStatus === EGameStatus.SELECT_WHO_START_VOTING ||
                                gameStatus === EGameStatus.PLAYER_VOTE_STATE ||
                                gameStatus === EGameStatus.PLAYER_VOTING ||
                                gameStatus === EGameStatus.SELECT_DIRECTION_OF_VOTE) && (_jsx(ListItem, Object.assign({ onClick: onVotesOpen }, { children: _jsx(ListItemText, { primary: "\u0413\u043E\u043B\u043E\u0441\u0430" }) }))), (gameButtonState === null || gameButtonState === void 0 ? void 0 : gameButtonState.visible) && (_jsx(PrimaryButton, { onClick: gameButtonState.onClick, disabled: gameButtonState.disabled, text: gameButtonState.text }))] }) })] }) }));
};
